import { object } from '@art-suite/art-core-ts';

// Import types from schemas - we only import types, not the schemas themselves
export type { ApiOrgContractor, ApiOrgContractorsMap } from '../ApiSchemas/RecordTypes/ApiOrgContractorSchema';

/**
 * Creates a map of contractors indexed by their ID for fast lookup.
 *
 * @param contractors - Array of contractors
 * @returns Record mapping contractor IDs to contractor objects
 */
export const getOrgContractorsMap = <T extends { id: string }>(contractors: T[]): Record<string, T> => object(contractors, { withKey: ({ id }) => id });
